import { createSlice } from '@reduxjs/toolkit';

import { alterarPapelUsuario } from './actions';

interface UsuarioPapelAdminState {
  saving: boolean;
  error: string | null;
}

const initialState: UsuarioPapelAdminState = {
  saving: false,
  error: null,
};

const usuarioPapelAdminSlice = createSlice({
  name: 'usuarioPapelAdmin',
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(alterarPapelUsuario.pending, (state) => {
        state.saving = true;
        state.error = null;
      })
      .addCase(alterarPapelUsuario.fulfilled, (state) => {
        state.saving = false;
      })
      .addCase(alterarPapelUsuario.rejected, (state, action) => {
        state.saving = false;
        state.error = (action.payload as string) ?? 'Erro ao alterar papel do usuário';
      });
  },
});

export const { clearError } = usuarioPapelAdminSlice.actions;
export default usuarioPapelAdminSlice.reducer;
